import ReviewsCard from '@/components/reviews-card';
import { useI18n } from '@/lib/i18n';
import Amex from '@images/Amex.svg';
import Klarna from '@images/Klarna.svg';
import Mastercard from '@images/Mastercard.svg';
import Swish from '@images/Swish.svg';
import Visa from '@images/Visa.svg';

export default function Brands({
  className,
  showText = false,
  showReviews = false,
}: {
  className?: string;
  showText?: boolean;
  showReviews?: boolean;
}) {
  const { t } = useI18n();

  return (
    <div className={`not-prose flex items-center space-x-1 md:space-x-2 ${className}`}>
      {showText && <span className="px-1 text-sm opacity-75">{t('layout.Pay with')}</span>}
      <img src={Swish} alt={'Swish'} className={'h-5 w-auto md:h-6'} />
      <img src={Klarna} alt={'Klarna'} className={'h-5 w-auto md:h-6'} />
      <img src={Visa} alt={'Visa'} className={'h-5 w-auto md:h-6'} />
      <img src={Mastercard} alt={'Mastercard'} className={'h-5 w-auto md:h-6'} />
      <img src={Amex} alt={'American Express'} className={'h-5 w-auto md:h-6'} />
      {showReviews && <ReviewsCard compact={true} />}
    </div>
  );
}
